import { render, staticRenderFns } from "./contentVideoMobile2.vue?vue&type=template&id=36c3d246&scoped=true&"
import script from "./contentVideoMobile2.vue?vue&type=script&lang=js&"
export * from "./contentVideoMobile2.vue?vue&type=script&lang=js&"
import style0 from "./contentVideoMobile2.vue?vue&type=style&index=0&id=36c3d246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c3d246",
  null
  
)

export default component.exports